export const ABOUT_US_PAGE_ID = 6;
export const PRODUCTS_PAGE_ID = 8;
export const CONTACT_PAGE_ID = 12;
export const HEMP_PAGE_ID = 10;
export const HERO_PAGE_ID = 27;
export const COMPOST_PAGE_ID = 54;
export const GRANULATE_PAGE_ID = 47;
export const MANUFACTURING_PAGE_ID = 468;
export const WHEREWECANMEET_PAGE_ID = 461;
export const TALKING_PAGE_ID = 465;